import React from 'react';

const StatusBadge = ({ statusLabel, statusTone, label, tone, message }) => {
  const actualLabel = label || statusLabel || 'Unknown';
  const actualTone = tone || statusTone || 'ghost';

  const badgeClass = 
    actualTone === 'success' ? 'bg-success/20 text-success' :
    actualTone === 'danger' || actualTone === 'error' ? 'bg-error/20 text-error' :
    actualTone === 'warning' ? 'bg-warning/20 text-warning-content' : 'bg-base-200 text-base-content';

  return (
    <span 
      className={`${badgeClass} border-none badge-sm uppercase font-bold px-3 py-3 rounded-full`}
      title={message}
    >
      {actualLabel}
    </span>
  );
};

export default StatusBadge;
